// libs
import React, { memo } from 'react';

// styles
import { ViewAllContainer, Title } from './styles';

// constants
const VIEW_ALL = 'View All';
const VIEW_ALL_EVENT = 'view-all-clicked';

// helpers
import { getWidgetListingURL } from './helpers';
import NFA from 'shared/helpers/analytics/NFAnalytics';

// defs
import { IWidgetData } from 'shared/layouts/DetailsPage/components/Widgets/types';

interface IViewAllButtonProps {
  widget: IWidgetData;
  productID: string;
}

function ViewAllButton({ widget, productID }: IViewAllButtonProps) {
  const actionURL = getWidgetListingURL(productID, widget);

  const redirect = (e: React.MouseEvent) => {
    e.preventDefault();
    NFA.track({
      event: VIEW_ALL_EVENT,
      data: {
        widgetTitle: widget?.title,
        widgetType: widget?.widget_type,
        listing_position: widget?.position,
      },
    });
    window.location.href = actionURL;
  };

  return (
    <ViewAllContainer onClick={redirect}>
      <Title>{VIEW_ALL}</Title>
    </ViewAllContainer>
  );
}

export default memo(ViewAllButton);
